import './Loader.css';
const LOGO = "/images/Logo.webp";
const LOGO1 = "/images/aroma.webp";

export default function Loader() {
  return (
    <div className="loader-screen">

      {/* Decorative background rings */}
      <div className="loader-ring loader-ring--1" />
      <div className="loader-ring loader-ring--2" />
      <div className="loader-ring loader-ring--3" />

      <div className="loader-content">

        {/* Top divider */}
        <div className="loader-divider">
          <div className="loader-div-line" />
          <span className="loader-div-dot" />
          <div className="loader-div-line" />
        </div>

        {/* Main Prakhyat logo */}
        <img src={LOGO} alt="Prakhyat" className="loader-logo-main" />

        {/* Separator */}
        <div className="loader-sep">✦</div>

        {/* Aroma logo */}
        <img src={LOGO1} alt="Aroma" className="loader-logo-aroma" />

        {/* Bottom divider */}
        <div className="loader-divider">
          <div className="loader-div-line" />
          <span className="loader-div-dot" />
          <div className="loader-div-line" />
        </div>

        {/* Progress bar */}
        <div className="loader-bar-wrap">
          <div className="loader-bar-fill" />
        </div>

        <p className="loader-text">✦ The Eternal Fragrance ✦</p>

      </div>
    </div>
  );
}
